// List Queries

import { gql } from "@apollo/client";

export const AddCustomer = gql`
  mutation AddCustomer(
    $token: String!
    $input: CreateMstCustomerInput!
    $user_details: SubscribedUser!
  ) {
    AddCustomer(token: $token, input: $input, user_details: $user_details) {
      id
    }
  }
`;

export const UpdateCustomer = gql`
  mutation UpdateCustomer(
    $token: String!
    $id: ID!
    $input: UpdateMstCustomerInput!
    $user_details: SubscribedUser!
  ) {
    UpdateCustomer(
      token: $token
      input: $input
      id: $id
      user_details: $user_details
    )
  }
`;
